import { useEffect, useState } from 'react'

const getInitial = (): boolean => {
  if (typeof document === 'undefined') return true
  return document.visibilityState !== 'hidden'
}

const useDocumentVisible = (): boolean => {
  const [isVisible, setIsVisible] = useState<boolean>(getInitial)

  useEffect(() => {
    if (typeof document === 'undefined') return undefined
    const handler = () => setIsVisible(document.visibilityState !== 'hidden')
    document.addEventListener('visibilitychange', handler)
    return () => document.removeEventListener('visibilitychange', handler)
  }, [])

  return isVisible
}

export default useDocumentVisible
